import { STATUS } from "@/constants/statuses";
import { EntityState, EntityStore, StoreConfig } from "@datorama/akita";
import { singleton } from "tsyringe";

import { WishlistWithItemsEntity } from "../entities/WishlistWithItemsEntity";

export interface ShareWishlistsState
    extends EntityState<WishlistWithItemsEntity, number> {
    status: STATUS;
    loadMoreStatus: STATUS;
}

export function createInitialState(): ShareWishlistsState {
    return {
        status: STATUS.VIRGIN,
        loadMoreStatus: STATUS.VIRGIN,
    };
}

@singleton()
@StoreConfig({ name: "shareWishlists" })
class ShareWishlistsStore extends EntityStore<ShareWishlistsState> {
    constructor() {
        super(createInitialState());
    }

    getStatus(): STATUS {
        return this.getValue().status;
    }

    getLoadMoreStatus(): STATUS {
        return this.getValue().loadMoreStatus;
    }

    setStatus(status: STATUS) {
        this.update(() => ({
            status,
        }));
    }

    setLoadMoreStatus(loadMoreStatus: STATUS) {
        this.update(() => ({
            loadMoreStatus,
        }));
    }
}

export default ShareWishlistsStore;
